import { request } from '@umijs/max';

export async function presignUpload(body: {
  prefix: string;       // 例: 'profile'
  contentType: string;  // file.type
  ext: string;          // 'png' | 'jpg' ...
}) {
  return request<{ key: string; putUrl: string; publicUrl: string; message?: string }>(
    '/uploads/presign',
    { method: 'POST', data: body },
  );
}

export async function uploadImage(file: File, prefix: string) {
  const ext = (file.name.split('.').pop() || 'jpg').toLowerCase();
  const contentType = file.type || 'image/jpeg';

  const presigned = await presignUpload({ prefix, contentType, ext });
  if (!presigned.putUrl) throw new Error(presigned.message || 'presign failed');

    let res: Response;
    try {
    res = await fetch(presigned.putUrl, {
        method: 'PUT',
        headers: { 'Content-Type': contentType },
        body: file,
    });
    } catch (e) {
    console.error('PUT failed', { putUrl: presigned.putUrl, e });
    throw e;
    }

    if (!res.ok) {
    const text = await res.text().catch(() => '');
    console.error('PUT not ok', res.status, text);
    throw new Error(`upload failed: ${res.status}`);
    }

  return { key: presigned.key, url: presigned.publicUrl };
}
